module.exports = __webpack_public_path__ + "img/register.1c9f3206.svg";